import { HttpContext, httpResource } from '@angular/common/http';
import { Service, computed } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ResponseApi } from '../../../../core/dtos/response-api';
import { HANDLE_HTTP_ERROR_LOCALLY, SKIP_AUTH_TOKEN } from '../../../../core/http/http-context-tokens';
import { PostoPresencialPublico } from '../models/posto-presencial-publico.model';

const RECURSO = `${environment.apiUrl}/ouvidoria/publico/postos-presenciais`;

/**
 * Os postos de atendimento presencial da Ouvidoria do órgão, lidos **uma vez por carga do portal**:
 * voltar ao `/ouvidoria/presencial` na mesma sessão não relê; recarregar a página relê.
 *
 * ⚠️ O portal **não sabe nem envia o órgão**: o back-end o resolve pelo host, e sem canal ativo a
 * lista vem vazia. Sem token — os postos não dependem de quem está logado —, e o erro fica local:
 * falha e `429` caem no mesmo estado vazio de lista vazia, sem modal.
 */
@Service()
export class PostoPresencialOuvidoriaService {
  private readonly postosApi = httpResource<ResponseApi<PostoPresencialPublico[]>>(() => ({
    url: RECURSO,
    context: new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true).set(SKIP_AUTH_TOKEN, true),
  }));

  /** Enquanto a leitura não termina, a tela não exibe nem os postos nem o estado vazio. */
  readonly carregando = computed(() => this.postosApi.isLoading());

  /** Os postos publicados, ou `[]` quando não há nenhum **ou** a leitura falhou. */
  readonly postos = computed<readonly PostoPresencialPublico[]>(() => {
    if (this.postosApi.error() !== undefined) return [];

    return this.postosApi.value()?.data ?? [];
  });
}
